import i18n from '@i18n';

/**
 * Adds accessible markup to the search form and input field.
 * Includes ARIA roles, visually hidden labels, and required fields.
 *
 * @param form - The HTML form element to enhance with accessibility features.
 * @param searchInput - The input element where the user types their query.
 */
export function setupAccessibility(form: HTMLFormElement, searchInput: HTMLInputElement, index: string): void {
	if (!form || !searchInput) {
		return;
	}

	// Set ARIA attributes for the form
	form.setAttribute('role', 'search');
	form.setAttribute('novalidate', '');

	// Add visually hidden heading for screen readers
	const heading = document.createElement('span');
	heading.className = 'visually-hidden';
	heading.textContent = i18n.t('heading');

	const headingId = `aex-search-heading-${index}`;
	heading.id = headingId;

	form.insertBefore(heading, form.firstChild);
	form.setAttribute('aria-labelledby', headingId);

	// Add required to input
	searchInput.setAttribute('required', '');

	// Create label for input
	const existingLabel = form.querySelector('label');

	const inputLabel = existingLabel || document.createElement('label');

	if (!existingLabel) {
		inputLabel.classList.add('visually-hidden');
		inputLabel.textContent = searchInput.getAttribute('placeholder');
	}

	const labelId = `aex-search-input-label-${index}`;
	inputLabel.id = labelId;

	const inputId = searchInput.getAttribute('id') || `aex-search-input-${index}`;
	inputLabel.setAttribute('for', inputId);
	searchInput.id = inputId;
	searchInput.setAttribute('type', 'search');

	// Insert label before the input
	const parent = searchInput.parentNode;
	if (parent && !existingLabel) {
		parent.insertBefore(inputLabel, searchInput);
	}
}
